enum CompanyType {
    ASSOCIATION_BDR = 'ASSOCIATION_BDR', // Biedrība
    BRANCH_OF_FOREIGN_COMPANY_AKF = 'BRANCH_OF_FOREIGN_COMPANY_AKF', // Ārvalsts komersanta filiāle
    CONGREGATION_DRZ = 'CONGREGATION_DRZ', // Reliģiskā draudze
    COOPERATIVE_SOCIETY_KB = 'COOPERATIVE_SOCIETY_KB', // Kooperatīvā sabiedrība
    FAMILY_UNDERTAKING_GIM = 'FAMILY_UNDERTAKING_GIM', // Ģimenes uzņēmums
    FARM_ZEM = 'FARM_ZEM', // Zemnieku saimniecība
    FISHING_UNDERTAKING_ZVJ = 'FISHING_UNDERTAKING_ZVJ', // Zvejnieku saimniecība
    FOREIGN_REPRESENTATIVE_OFFICE_PAR = 'FOREIGN_REPRESENTATIVE_OFFICE_PAR', // Ārvalsts pārstāvniecība
    FOUNDATION_NOD = 'FOUNDATION_NOD', // Nodibinājums
    GENERAL_PARTNERSHIP_PS = 'GENERAL_PARTNERSHIP_PS', // Pilnsabiedrība
    INDIVIDUAL_UNDERTAKING_IND = 'INDIVIDUAL_UNDERTAKING_IND', // Individuālais uzņēmums
    JURIDIC_PERSON_UNDER_CANON_LAW_KAT = 'JURIDIC_PERSON_UNDER_CANON_LAW_KAT', // Kanonisko tiesību juridiskā persona
    LIMITED_LIABILITY_COMPANY_SIA = 'LIMITED_LIABILITY_COMPANY_SIA', // Sabiedrība ar ierobežotu atbildību (SIA)
    LIMITED_PARTNERSHIP_KS = 'LIMITED_PARTNERSHIP_KS', // Komandītsabiedrība
    MONASTERY_KLO = 'MONASTERY_KLO', // Klosteris
    PUBLIC_BODY = 'PUBLIC_BODY', // Publisko tiesību juridiskā persona / iestāde
    PUBLIC_LIMITED_COMPANY_AS = 'PUBLIC_LIMITED_COMPANY_AS', // Akciju sabiedrība (AS)
    SOLE_TRADER_IK = 'SOLE_TRADER_IK', // Individuālais komersants (IK)
}

export default CompanyType;
